import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core'
import { ClipboardService } from 'src/app/services/clipboard.service'

@Directive({
  selector: '[copy-clipboard]',
  standalone: true,
})
export class CopyClipboardDirective {
  @Input('copy-clipboard')
  public payload: string

  @Output('copied')
  public copied: EventEmitter<string> = new EventEmitter<string>()

  constructor(private clipboard: ClipboardService) {}

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    event.preventDefault()
    if (!this.payload) return
    this.clipboard.copy(this.payload).then((ok) => {
      if (ok) this.copied.emit(this.payload)
    })
  }
}
